<!--
 - Author : wanghongling.
 - Date   : 2019/6/6.
 - File   : main.弹窗组件
 -->

<template>
  <el-dialog :title="title"
      class="img-view-ct"
      :visible.sync="visible"
      :modal-append-to-body="false"
      :close="handleClose"
      center>
    <div class="mainCont" v-if="content">
      <p class="diaContent">{{content}}</p>
    </div>
    <div v-if="!imgPic.includes('hyjx.com')">
      <i class="el-icon-download i-download" v-if="imgPic || (picList&&picList.length>0)" @click="downloadCodeImg()"></i>
    </div>
    <div class="imgCont" v-if="imgPic">
      <img class="mainPic" :src="imgPic" alt="">
    </div>
    <el-carousel class="newCarousel" arrow="always"  v-if="picList&&picList.length>0" @change="changeImg">
      <el-carousel-item height="500px" v-for="(item,i) in picList" :key="i">
        <img class="mainPic" :src="imgUrl+item" alt="">
      </el-carousel-item>
    </el-carousel>
    <span slot="footer" v-if="btnShow" class="footer-btn">
      <el-button @click="leftBtnFn" v-show="cancelBtn">{{leftText}}</el-button>
      <el-button type="primary" @click="rightBtnFn">{{rightText}}</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: 'MessageBox',
    data () {
      return {
        title: '查看图片',
        content: '确认执行当前操作吗？',
        imgUrl: SERVERCONFIG.VUE_APP_BASE_API + '/fjxhx/file/server/api/file/',
        imgPic: '',
        imgPic1: '',
        picList: [],
        visible: false,
        leftText: '取 消',
        rightText: '确 定',
        callback: null,
        action: null,
        cancelBtn: false,
        btnShow: true
      }
    },
    methods: {
      init () {
        this.btnShow = true
        this.cancelBtn = false
        this.imgPic = ''
        this.picList = []
      },
      /**
       * 关闭查看图片框
       * @author: whl
       * @createDate: 2019/6/6
       * @return {Object}
       */
      handleClose () {
        this.visible = false
        this.imgPic = ''
        this.imgPic1 = ''
      },
      /**
       * 左边按钮的操作，按钮名可以自定义（如取消，确定）
       * @author wanghongling
       */
      leftBtnFn () {
        this.action = {
          value: 'cancel'
        }
        this.callback(this.action, this)
        this.handleClose()
      },
      /**
       * 右边按钮的操作，按钮名可以自定义（如取消，确定）
       * @author wanghongling
       */
      rightBtnFn () {
        this.action = {
          value: 'confirm'
        }
        this.callback(this.action, this)
        this.handleClose()
      },
      /**
       * 下载图片,调用qt方法
       * @author wanghongling
       */
      downloadCodeImg() {
        // try {
        //   if (this.picList.length > 0) {
        //     window.getCefQuery(`getImg||${this.imgPic1}`)
        //   } else {
        //     window.getCefQuery(`getImg||${this.imgPic}`)
        //   }
        // } catch (e) {
        //   this.$superMessage('提示', '请在Qt上访问')
        // }
        // this.downs(this.imgPic, Math.random().toString(36).substr(2))
        // window.location.href = this.imgPic
        const link = document.createElement('a')
        link.href = this.imgPic
        link.click() // 下载文件
      },
      /**
       * @description: (访问的网站与服务器域名不一致)不同源下载图片的方法
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-09-03 9:00
       * @param: (访问的网站与服务器域名不一致)不同源下载图片的方法
       * @return:
      */
      downs(imgSrc, name) {
        let image = new Image()
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function() {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/jpg')
          let a = document.createElement('a')
          let event = new MouseEvent('click')
          a.download = name || 'photo'
          a.href = url
          a.dispatchEvent(event)
        }
        image.src = imgSrc
      },
      /**
       * 切换图片传相应的图片id
       * @param e
       */
      changeImg(e) {
        this.imgPic1 = this.picList[e]
      }
    },
    watch: {
      visible (cur) {
        if (!cur) {
          setTimeout(this.init, 300)
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .mainCont{
    min-width: 300px;
    max-width: 420px;
    min-height: 50px;
  }
  .imgCont{
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 300px;
    min-height: 300px;
  }
  .mainPic{
    /*min-width: 300px;*/
    /*min-height: 300px;*/
  }
  .diaContent{
    padding: 20px;
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
  .newCarousel{
    height: 100%;
    width: 100%;
    min-width: 800px;
    min-height: 800px;
    .el-carousel__container{
      height: 100%;
      width: 100%;
      position: initial;
      margin: 0 auto;
      img{
        /*height: 100%;*/
        width: 100%;
      }
    }
  }
  .footer-btn{
    .el-button{
      padding: 10px 40px !important;
      background-color: #35556d;
      border-color: #35556d;
      color: #fff;
    }
    .el-button--primary {
      font-size: 16px !important;
      background-color: #009cff;
      border-color: #009cff;
    }
    .el-button--primary:hover{
      background-color: #e68d00 !important;
      border-color: #e68d00 !important;
    }
    .el-button:hover{
      background-color: #045591;
      border-color: #045591;
    }
  }
  .i-download{
    position: absolute;
    right: 49px;
    top: 6px;
    font-size: 30px;
    color: #00fbfa;
    cursor: pointer;
  }
  .i-download:hover{
    opacity: .5;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/src/main.vue